module.exports = __webpack_public_path__ + "img/image15.2e88bafb.jpg";